import { api } from "../../../utils/api";
import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MobileLayout from "../../../layouts/MobileLayout";
import RegularizationForm from "../../../components/mobile/RegularizationForm";
import { useAuthStore } from "../../../store/authStore";
import { toast } from "react-toastify";

const AttendanceRegularization = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const { user, isAuthenticated } = useAuthStore();

  const companyId = user?.company_id;
  const userId = user?.user_id;

  const inParts =
    state?.inTime && state.inTime !== "-" ? state.inTime.split(":") : ["", ""];

  const outParts =
    state?.outTime && state.outTime !== "-"
      ? state.outTime.split(":")
      : ["", ""];

  const [inHour, setInHour] = useState(inParts[0]);
  const [inMinute, setInMinute] = useState(inParts[1]);

  const [outHour, setOutHour] = useState(outParts[0]);
  const [outMinute, setOutMinute] = useState(outParts[1]);

  const [remarks, setRemarks] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false);

  // const handleApply = async () => {

  //    if (
  //     state?.shiftType === "Weekoff" ||
  //     state?.shiftType === "Holiday"
  //   ) {
  //     alert(
  //       state?.shiftType === "Weekoff"
  //         ? "Attendance regularization is not allowed on Week Off."
  //         : "Attendance regularization is not allowed on Holiday."
  //     );
  //     return;
  //   }
  //   if (
  //     inHour === "" ||
  //     inMinute === "" ||
  //     outHour === "" ||
  //     outMinute === ""
  //   ) {
  //     alert("Please enter complete In Time and Out Time");
  //     return;
  //   }

  //   if (
  //     Number(inHour) < 0 ||
  //     Number(inHour) > 23 ||
  //     Number(outHour) < 0 ||
  //     Number(outHour) > 23
  //   ) {
  //     alert("Hour must be between 00 and 23");
  //     return;
  //   }

  //   if (
  //     Number(inMinute) < 0 ||
  //     Number(inMinute) > 59 ||
  //     Number(outMinute) < 0 ||
  //     Number(outMinute) > 59
  //   ) {
  //     alert("Minute must be between 00 and 59");
  //     return;
  //   }

  //   if (!token) {
  //     alert("Session expired. Please login again.");
  //     return;
  //   }

  //   if (!companyId || !userId) {
  //     alert("User information is missing.");
  //     return;
  //   }

  //   try {
  //     const [day, month, year] = state.date.split("/");

  //     const formattedDate = `${year}-${month}-${day}`;

  //     const inDateTime = `${formattedDate}T${String(inHour).padStart(
  //       2,
  //       "0",
  //     )}:${String(inMinute).padStart(2, "0")}:00`;

  //     const outDateTime = `${formattedDate}T${String(outHour).padStart(
  //       2,
  //       "0",
  //     )}:${String(outMinute).padStart(2, "0")}:00`;

  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_BASE_URL}/attendance/missing-punch/request`,
  //       {
  //         method: "POST",
  //         headers: {
  //           accept: "application/json",
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify({
  //           company_id: companyId,
  //           user_id: userId,
  //           employee_code: user?.employee_code || "",
  //           punch_id: state?.punchId || 0,
  //           out_id: state?.outId || 0,
  //           in_datetime: inDateTime,
  //           out_datetime: outDateTime,
  //         }),
  //       },
  //     );

  //     const result = await response.json();

  //     if (!response.ok || !result.status) {
  //       throw new Error(
  //         result.message || "Unable to submit missing punch request",
  //       );
  //     }

  //     alert(
  //       result.message ||
  //         "Missing punch request submitted for approval.",
  //     );

  //     navigate(-1);
  //   } catch (err) {
  //     console.error("Missing punch request error:", err);
  //     alert(err.message || "Something went wrong");
  //   }
  // };

  const handleApply = async () => {
  if (submittingRef.current || submitted) return;
    if (state?.shiftType === "Weekoff" || state?.shiftType === "Holiday") {
      toast.warning(
        state?.shiftType === "Weekoff"
          ? "Attendance regularization is not allowed on Week Off."
          : "Attendance regularization is not allowed on Holiday.",
      );
      return;
    }

    if (
      inHour === "" ||
      inMinute === "" ||
      outHour === "" ||
      outMinute === ""
    ) {
      toast.warning("Please enter complete In Time and Out Time");
      return;
    }

    if (
      Number(inHour) < 0 ||
      Number(inHour) > 23 ||
      Number(outHour) < 0 ||
      Number(outHour) > 23
    ) {
      toast.warning("Hour must be between 00 and 23");
      return;
    }

    if (
      Number(inMinute) < 0 ||
      Number(inMinute) > 59 ||
      Number(outMinute) < 0 ||
      Number(outMinute) > 59
    ) {
      toast.warning("Minute must be between 00 and 59");
      return;
    }

    // ==========================================
// OUT TIME MUST NOT BE LESS THAN IN TIME
// ==========================================
const inTotalMinutes =
  Number(inHour) * 60 + Number(inMinute);

const outTotalMinutes =
  Number(outHour) * 60 + Number(outMinute);

if (outTotalMinutes < inTotalMinutes) {
  toast.warning("Out Time cannot be earlier than In Time.");
  return;
}

    if (!isAuthenticated) {
      toast.error("Session expired. Please login again.");
      return;
    }

    if (!companyId || !userId) {
      toast.error("User information is missing.");
      return;
    }

    submittingRef.current = true;
  setIsSubmitting(true);
  try {
      const [day, month, year] = state.date.split("/");

      const formattedDate = `${year}-${month}-${day}`;

      const inDateTime = `${formattedDate}T${String(inHour).padStart(
        2,
        "0",
      )}:${String(inMinute).padStart(2, "0")}:00`;

      const outDateTime = `${formattedDate}T${String(outHour).padStart(
        2,
        "0",
      )}:${String(outMinute).padStart(2, "0")}:00`;

      const response = await api.post(
        `/attendance/missing-punch/request?company_id=${encodeURIComponent(
    companyId
  )}`,
        {
          company_id: companyId,
          user_id: userId,
          employee_code: user?.employee_code || "",
          punch_id: state?.punchId || 0,
          out_id: state?.outId || 0,
          in_datetime: inDateTime,
          out_datetime: outDateTime
        },
        { headers: { Accept: "application/json" } },
      );

      const result = await response.json();

      if (!response.ok || !result.status) {
        throw new Error(
          result.message ||
            result.detail ||
            "Unable to submit missing punch request",
        );
      }

      setSubmitted(true);
    } catch (err) {
      console.error("Missing punch request error:", err);

      toast.error(err.message || "Something went wrong");
    } finally {
      submittingRef.current = false;
      setIsSubmitting(false);
    }
  };
  return (
    <MobileLayout>
      <RegularizationForm
        submitted={submitted}
        isSubmitting={isSubmitting}
        onDone={() => navigate(-1)}
        state={state}
        inHour={inHour}
        inMinute={inMinute}
        outHour={outHour}
        outMinute={outMinute}
        onInHourChange={setInHour}
        onInMinuteChange={setInMinute}
        onOutHourChange={setOutHour}
        onOutMinuteChange={setOutMinute}
        remarks={remarks}
        onRemarksChange={setRemarks}
        onApply={handleApply}
        onBack={() => navigate(-1)}
      />
    </MobileLayout>
  );
};

export default AttendanceRegularization;
